function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_822_276)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_822_276)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 85,
  height: 28,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.0017 -0.0114841H0V28.0078H85.0017V-0.0114841Z",
  fill: "url(#paint0_linear_822_276)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5642 33.522C0.559858 24.1531 1.58625 30.9396 -10.4487 31.0323L-3.29447 -6.64007C4.70696 -10.5582 6.3207 -6.89158 29.7971 -0.629185L69.411 32.5331C59.8386 34.0317 48.5684 42.8909 24.5642 33.522Z",
  fill: "url(#paint1_linear_822_276)",
  fillOpacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.7001 -1.56572L-2.90323 -0.940904L-1.52902 19.1425L16.1877 19.68C26.922 18.2836 37.8119 20.8028 44.0349 26.3453L54.8776 36.0024C56.535 37.4807 58.7564 38.6901 61.3498 39.5259C63.9432 40.3618 66.8307 40.7991 69.7626 40.8H124.115V25.6015C124.115 22.663 119.471 20.5663 114.895 21.439L88.4397 27.4812C85.8677 27.8218 83.1853 27.6551 80.7783 27.0048C78.3713 26.3546 76.3637 25.2545 75.0443 23.8628L57.7001 -1.56572Z",
  fill: "url(#paint2_linear_822_276)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 35.9053,
  cy: 13.9867,
  rx: 15.5749,
  ry: 11.1333,
  fill: "url(#paint3_radial_822_276)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 52.5936,
  cy: 22.6963,
  rx: 29.2085,
  ry: 14.12,
  fill: "url(#paint4_radial_822_276)",
  fillOpacity: 0.7
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 18.7893,
  ry: 8.70989,
  transform: "matrix(0.982827 0.184532 -0.44903 0.893517 54.9043 25.0454)",
  fill: "url(#paint5_radial_822_276)",
  fillOpacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.1918 -0.63545L-0.203339 -0.177743L0.803342 14.5344L13.7817 14.9282C21.6452 13.9052 29.6227 15.7507 34.1813 19.8108L42.1242 26.8852C43.3383 27.9681 44.9656 28.854 46.8654 29.4663C48.7652 30.0787 50.8804 30.399 53.0282 30.3997H92.8441L97.0356 11.4995C97.0356 9.34688 93.6334 7.81093 90.2817 8.45026L88.3354 -3.19113C86.4513 -2.94162 84.4864 -3.06381 82.7231 -3.54012C80.9598 -4.01643 79.4892 -4.82232 78.5226 -5.84186L44.1918 -0.63545Z",
  fill: "url(#paint6_linear_822_276)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4265 18.0523C15.186 18.0484 14.9459 18.0293 14.7077 17.9952C13.989 17.878 13.5304 17.5264 13.3349 16.9475C13.2471 16.7056 13.1986 16.4514 13.1911 16.1943V11.8723L13.6152 11.8537C14.5223 11.8094 15.484 11.7437 16.3969 11.4921L15.8147 9.51833L13.1911 9.90565V7H10.0931V9.90565H8V11.898H10.0931C10.0931 11.898 10.0931 16.0071 10.1104 17.0562C10.1121 17.6969 10.2982 18.3237 10.6466 18.8627C11.0635 19.493 11.6687 19.8875 12.5542 20.1047C13.505 20.3371 14.4686 20.3263 15.4865 20.3149L15.4941 20.3148H15.7385V18.0638H15.6206L15.4265 18.0523ZM21.6743 9.76131C23.1751 9.44545 24.3669 9.66841 25.5989 10.1286C27.0666 10.6775 27.9177 11.878 27.9162 13.4316V20.292H25.0914V18.3296L24.4143 18.8513C24.3714 18.8847 24.26 18.9801 24.1817 19.0473C24.1393 19.0836 24.1065 19.1116 24.0995 19.1171C23.1402 19.921 21.9162 20.3444 20.6622 20.3063C20.1491 20.3153 19.6416 20.1987 19.1846 19.9666C18.7275 19.7346 18.335 19.3942 18.0415 18.9756C17.708 18.5169 17.5499 17.9523 17.5412 17.1991C17.5182 15.2196 18.8307 14.5993 19.9348 14.4264C20.2943 14.3701 20.6577 14.3419 21.0216 14.342C22.1039 14.3586 23.1747 14.5657 24.1843 14.9538L24.2475 14.9781L24.3252 15.0081C24.4225 15.0442 24.5297 15.0442 24.6271 15.0081L25.1187 14.9037C25.1187 14.9037 25.0785 13.616 25.0181 13.3044C24.87 12.5526 23.9715 12.0395 23.0342 12.0581C22.2263 12.0738 21.473 12.7627 21.0417 13.3744C20.4969 12.9685 20.0901 12.6198 19.6976 12.2811C19.459 12.0738 19.2146 11.8652 18.9429 11.6451C19.561 10.4759 20.5026 10.0071 21.6743 9.76131ZM22.0049 18.2582C23.1377 18.2582 24.1225 17.6507 24.7263 16.5759L25.0713 15.9585H19.8773L19.8601 16.3573C19.8256 17.2691 20.3071 17.9466 21.1539 18.1681C21.3857 18.2231 21.6228 18.2533 21.8612 18.2582H22.0049ZM51.1834 9.76131C52.6828 9.44545 53.8746 9.66841 55.1066 10.1286C56.5743 10.6775 57.4254 11.878 57.4254 13.4316V20.292H54.6006V18.3296L53.9235 18.8513C53.873 18.8914 53.722 19.0211 53.6491 19.0837L53.6101 19.1171C52.6503 19.9211 51.4258 20.3445 50.1714 20.3063C49.6583 20.3153 49.1508 20.1987 48.6937 19.9666C48.2367 19.7346 47.8441 19.3942 47.5507 18.9756C47.2186 18.5169 47.059 17.9523 47.0504 17.1991C47.0274 15.2196 48.3399 14.5993 49.444 14.4264C49.8035 14.3701 50.1668 14.3419 50.5308 14.342C51.6131 14.3586 52.6838 14.5657 53.6934 14.9538L53.7581 14.9781C53.784 14.9895 53.8113 14.9995 53.8358 15.0081C53.9331 15.0442 54.0403 15.0442 54.1377 15.0081L54.6279 14.9037C54.6279 14.9037 54.5876 13.616 54.5272 13.3044C54.3792 12.5526 53.4821 12.0395 52.5434 12.0581C51.7369 12.0738 50.9822 12.7627 50.5509 13.3744C50.0071 12.9693 49.6022 12.6211 49.209 12.283L49.2089 12.2829L49.2068 12.2811C48.9681 12.0738 48.7237 11.8652 48.452 11.6451C49.0688 10.4759 50.0104 10.0071 51.1834 9.76131ZM51.5141 18.2582C52.6455 18.2582 53.6316 17.6507 54.234 16.5759L54.5804 15.9585H49.3879L49.3706 16.3573C49.3347 17.2691 49.8163 17.9466 50.6645 18.1681C50.8958 18.2231 51.1325 18.2533 51.3703 18.2582H51.5141ZM74.4061 10.1286C73.1741 9.66841 71.9823 9.44545 70.4815 9.76131C69.3099 10.0071 68.3682 10.4759 67.7501 11.6451C68.0218 11.8652 68.2662 12.0738 68.5048 12.2811C68.8973 12.6198 69.3041 12.9685 69.8489 13.3744C70.2802 12.7627 71.0335 12.0738 71.8414 12.0581C72.7802 12.0395 73.6772 12.5526 73.8253 13.3044C73.8857 13.616 73.9259 14.9037 73.9259 14.9037L73.4343 15.0081C73.3373 15.0439 73.2307 15.0439 73.1338 15.0081C73.1094 14.9995 73.0821 14.9895 73.0562 14.9781L72.9915 14.9538C71.9819 14.5657 70.9111 14.3586 69.8288 14.342C69.4649 14.3419 69.1015 14.3701 68.742 14.4264C67.638 14.5993 66.3254 15.2196 66.3484 17.1991C66.3571 17.9523 66.5152 18.5169 66.8487 18.9756C67.1422 19.3942 67.5347 19.7346 67.9918 19.9666C68.4488 20.1987 68.9563 20.3153 69.4694 20.3063C70.7238 20.3445 71.9483 19.9211 72.9081 19.1171L72.9474 19.0835L72.9482 19.0828L72.9485 19.0826C73.0218 19.0196 73.1714 18.8912 73.2215 18.8513L73.8986 18.3296V20.292H76.7234V13.4316C76.7249 11.878 75.8738 10.6775 74.4061 10.1286ZM73.5335 16.5759C72.9297 17.6507 71.9449 18.2582 70.8121 18.2582H70.6684C70.43 18.2533 70.1929 18.2231 69.9611 18.1681C69.1143 17.9466 68.6328 17.2691 68.6673 16.3573L68.6845 15.9585H73.8756L73.5335 16.5759ZM63.1671 11.7165C63.5983 10.9347 64.2496 10.5374 65.1639 10.4959C65.3709 10.4859 65.5808 10.4874 65.8093 10.4902V13.1643L65.7645 13.1648C65.5441 13.1669 64.7099 13.1747 64.3603 13.2244C63.777 13.2945 63.2367 13.5647 62.8323 13.9884C62.4279 14.4121 62.1849 14.9627 62.145 15.5455C62.1305 15.7683 62.1354 15.9912 62.1402 16.2107C62.1426 16.3191 62.145 16.4267 62.145 16.5331V16.706V19.4344V20.3134H59.4064V10.6346H62.1378V11.9095V12.2411L62.8149 12.3968C62.8149 12.3968 63.1196 11.8023 63.1671 11.7165ZM40.7078 13.0286C39.8093 13.1115 39.148 13.8833 39.148 14.8609V20.3063H36.2844V14.9595C36.3087 14.5136 36.1861 14.072 35.935 13.7017C35.5109 13.1286 34.7016 12.8799 33.9224 13.08C33.5896 13.1619 33.2905 13.3445 33.0665 13.6025C32.8425 13.8606 32.7045 14.1814 32.6717 14.5207C32.6486 14.7003 32.6371 14.8813 32.6372 15.0624V20.3134H29.7908V10.6332H32.6487V12.807L33.0599 12.0924C33.977 10.4931 35.7596 10.2173 36.9413 10.546C38.0396 10.859 38.7282 11.7265 38.9698 12.9242L39.3895 12.0896C40.3096 10.4902 42.2906 10.2444 43.4722 10.5731C44.5634 10.8818 45.2103 11.6136 45.4374 12.8142C45.492 13.1247 45.518 13.4395 45.515 13.7546V18.8013V20.3006H42.7836V19.3373V15.0009C42.7887 14.8225 42.7767 14.644 42.7477 14.4678C42.5536 13.4659 41.7917 12.9271 40.7078 13.0286Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_822_276",
  x1: 0.809442,
  y1: 24.9153,
  x2: 67.6169,
  y2: -21.9312,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#AAE1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427083,
  stopColor: "#F9BD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#FFBC8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.640625,
  stopColor: "#FFBE92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#F8BC8B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#F29F7E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F0826B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_822_276",
  x1: 44.5334,
  y1: 11.5594,
  x2: 7.72128,
  y2: 60.0486,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.463182,
  stopColor: "#CAEDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#98D6F7",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_822_276",
  x1: 18.3607,
  y1: 0.644423,
  x2: 32.043,
  y2: 44.22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#FFE08B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.130208,
  stopColor: "#FFE294",
  stopOpacity: 0.590397
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303475,
  stopColor: "#FFD972",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_822_276",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(35.9053 13.9867) rotate(90) scale(11.1333 15.5749)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8B483",
  stopOpacity: 0.57
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8B483",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_822_276",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(52.5936 22.6963) rotate(90) scale(14.12 29.2085)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EB84A4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.755208,
  stopColor: "#EB84A4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_822_276",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.7893 8.70989) rotate(90) scale(8.70989 18.7893)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EB84A4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.755208,
  stopColor: "#EB84A4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_822_276",
  x1: 37.7014,
  y1: 14.3344,
  x2: 66.6693,
  y2: 43.0222,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.326812,
  stopColor: "#EB84A4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9881BB"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_822_276"
}, /*#__PURE__*/React.createElement("rect", {
  width: 85,
  height: 28,
  rx: 8,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_822_276"
}, /*#__PURE__*/React.createElement("rect", {
  width: 85,
  height: 28,
  fill: "white"
})));

var SvgTamara = function SvgTamara(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "tamara-badge lang--en",
    style: {
      display: "inline",
      verticalAlign: "middle"
    },
    width: 76,
    height: 24,
    viewBox: "0 0 85 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTamara, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tamara.46c0e616.svg";
export { ForwardRef as ReactComponent };